<template>
  <!-- MAIN CONTENT - TOOLBOX -->
  <div class="main-content">
    <h1 v-translate>Task Manager</h1>
    <div class="main-content__task-manager">
      <coming-soon/>
    </div>
    <!-- // END MAIN CONTENT - TOOLBOX -->
  </div>
</template>
<script>
import ComingSoon from "../components/ComingSoon";

export default {
  components: {
    ComingSoon
  },
}
</script>
